var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13344_10475",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 105
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    fill: "#F4F4F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13344_10475)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13344_10475)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.9689,
    y: 32.9919,
    width: 54.5203,
    height: 72.008,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7189,
    y: 33.7419,
    width: 53.0203,
    height: 70.508,
    rx: 3.25,
    stroke: "#EFEFEF",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13344_10475)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.6198,
    y: 22.6428,
    width: 54.5203,
    height: 72.008,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3698,
    y: 23.3928,
    width: 53.0203,
    height: 70.508,
    rx: 3.25,
    stroke: "#EFEFEF",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 26.088,
    y: 56.075,
    width: 23.2857,
    height: 3.88095,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.961,
    y: 56.075,
    width: 11.6428,
    height: 3.88095,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.842,
    y: 66.4241,
    width: 11.6428,
    height: 3.88095,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.6753,
    y: 66.4241,
    width: 23.2857,
    height: 3.88095,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13344_10475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7295 38.9686C53.591 39.305 52.2457 39.4602 50.6674 39.4602H42.9055C41.3273 39.4602 39.9819 39.305 38.8434 38.9686C39.128 35.6051 42.5821 32.9531 46.7865 32.9531C50.9908 32.9531 54.4449 35.6051 54.7295 38.9686Z",
    fill: "#EFEFEF",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_13344_10475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6674 13.5874H42.9055C36.4372 13.5874 33.8499 16.1747 33.8499 22.6429V30.4048C33.8499 35.2948 35.3247 37.9727 38.8434 38.9688C39.128 35.6053 42.582 32.9533 46.7864 32.9533C50.9908 32.9533 54.4448 35.6053 54.7294 38.9688C58.2481 37.9727 59.7229 35.2948 59.7229 30.4048V22.6429C59.7229 16.1747 57.1356 13.5874 50.6674 13.5874ZM46.7864 29.3311C44.225 29.3311 42.1551 27.2484 42.1551 24.6869C42.1551 22.1255 44.225 20.0557 46.7864 20.0557C49.3478 20.0557 51.4177 22.1255 51.4177 24.6869C51.4177 27.2484 49.3478 29.3311 46.7864 29.3311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6674 13.5874H42.9055C36.4372 13.5874 33.8499 16.1747 33.8499 22.6429V30.4048C33.8499 35.2948 35.3247 37.9727 38.8434 38.9688C39.128 35.6053 42.582 32.9533 46.7864 32.9533C50.9908 32.9533 54.4448 35.6053 54.7294 38.9688C58.2481 37.9727 59.7229 35.2948 59.7229 30.4048V22.6429C59.7229 16.1747 57.1356 13.5874 50.6674 13.5874ZM46.7864 29.3311C44.225 29.3311 42.1551 27.2484 42.1551 24.6869C42.1551 22.1255 44.225 20.0557 46.7864 20.0557C49.3478 20.0557 51.4177 22.1255 51.4177 24.6869C51.4177 27.2484 49.3478 29.3311 46.7864 29.3311Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.4177 24.687C51.4177 27.2484 49.3478 29.3311 46.7864 29.3311C44.225 29.3311 42.1552 27.2484 42.1552 24.687C42.1552 22.1255 44.225 20.0557 46.7864 20.0557C49.3478 20.0557 51.4177 22.1255 51.4177 24.687Z",
    fill: "#EFEFEF",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13344_10475",
    x: 21.9689,
    y: 26.9919,
    width: 70.5203,
    height: 88.0081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13344_10475"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13344_10475",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13344_10475",
    x: 11.6198,
    y: 16.6428,
    width: 70.5203,
    height: 88.0081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13344_10475"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13344_10475",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13344_10475",
    x: 25.0999,
    y: 6.8374,
    width: 43.373,
    height: 42.8813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13344_10475"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13344_10475",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13344_10475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.0476,
    height: 31.0476,
    fill: "white",
    transform: "translate(31.2626 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState4);
export default __webpack_public_path__ + "static/media/EmptyState4.0680346399ea8b89d2ac0a97b916887d.svg";
export { ForwardRef as ReactComponent };